import { v4 as uuid } from "uuid";
import CommunicationCycleAPI from "@/api/CommunicationCycleAPI";
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {COMCYCLE} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";
import CalenderHelperClass from '@/helpers/CalenderHelper'
import moment from 'moment';

import CommunicationCycleInit from "./initialValues/CommunicationCycle" 
import DB from "@/models/DB";
import { DayModel, TodoModel, ContactModel, AppointmentModel } from "@/models/CommunicicationCycle/CommunicationCycle";
export let calenderSettings = localStorage.getItem("calender_settings");

if(calenderSettings) {
    calenderSettings = JSON.parse(calenderSettings);
}

let initialState = {
    selected: false,
    item: null,
    items: null,
    initItems: [],
    users: null,
    selectedUsers: [],
    schedule: null,
    priority: false,
    event_types: false,
    view: COMCYCLE.VIEW_OVERVIEW,
    apiState: COMCYCLE.API_INIT,
    selectedDate: moment(), 
    key: "",
    error: null,
    calenderSettings: calenderSettings,
    needToUpdate: true,
    dragItem: null,
    dragOverElement: null,
    scheduleItem: null,
    usersSchedules: null,
    reset() {
        let newObj = {...this};
        newObj.items = null;
        newObj.selectedDate = moment();
        newObj.selectedUsers = [];
        newObj.users = [];
        newObj.item = null;
        return newObj;
    }
};


const rejectEventHandler=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);
});
const pendingEventHandler=((state, action) => {
    state.apiState = COMCYCLE.API_PROCESSING;
})
let fullFilledEventHandler= ( (state, action) => {
        if(action.payload.data.state == 9) {
            let events = current(state.items)[action.payload.data.from];
            if(events) {
                events = CalenderHelperClass.removeEvent([...events], action.payload.data);
                if(events && events.length > 0) {
                    delete state.items[action.payload.data.from];
                } else {
                    state.items[action.payload.data.from] = events;
                }
            }
            state.apiState = COMCYCLE.API_REFRESH;
         }
    if(action.payload.data.usersSchedules) {
                state.usersSchedules = action.payload.data.usersSchedules; 
                state.apiState = COMCYCLE.API_REFRESH;
                state.needToUpdate = true;
      
    }
    if(action.payload.data.item) {
        let model;
        let item = action.payload.data.item;
        switch(item?.modelName) {
            case "TodoModel":
                item = model = new TodoModel(item);
                break;
            case "ContactModel":
                item = model = new ContactModel(item);
                break;
            case "AppointmentModel":
                item = model = new AppointmentModel(item);
                break;
                default:
                    model = item;
                    break;
        }
        
        
        state.item = model;
        
            //console.debug( "UPDATE ITEM!!!!!", state.items.findChildByKey( action.payload.data.item.dayKey, 'uid' ) );
        if(state.items) {
            let prevItems = state.items;
            let selectedDay = prevItems.findChildByKey( item.dayKey, 'uid' );
            let isNewItem = false;
            if(! prevItems.has( item.dayKey ) ) {
                selectedDay = DB.newModel({uid: item.dayKey}, DayModel);
                selectedDay.items.add(item);
                prevItems.add(selectedDay);
                isNewItem = true;    
            } else {
//                selectedDay = prevItems.findChildByKey( item.dayKey );
                if(selectedDay) {
                    let updateIndex = selectedDay.items.getIndexForKey(item.key, 'com_key');
                    if(updateIndex >= 0) {
                        selectedDay.items.update( updateIndex, item );
                    } else {
                        selectedDay.items.add( item );
                    }
                }
            }
            state.items = prevItems;
            console.debug("sdsdsdf", state.items )

        if(action.payload.data.state == -99999.1) {
            let events = current(state.items)[action.payload.data.from];
            if(!events) {
                events = [];                
            }
            events = CalenderHelperClass.removeEvent([...events], state.item);
            if(events && Array.isArray(events) && events.length == 0) {
                delete state.items[action.payload.data.from];
            } else {
                state.items[action.payload.data.from] = events;
            }
            events = current(state.items)[state.item.dayKey];
            if(!events) {
                events = [];                
            }
            events = CalenderHelperClass.addEvent([...events], state.item);
            if(events && Array.isArray(events) && events.length == 0) {
                delete state.items[state.item.dayKey];
            } else {
                state.items[state.item.dayKey] = events;
            }
        }
        if(action.payload.data.state == -99999) {
            if(state.items && Array.isArray(state.items) && state.items.length >= 0) {
                let events = state.items[state.item.dayKey];
                if(events && Array.isArray(events)) {
                    events.push(state.item);
                    state.items[state.item.dayKey] = events;
                } else if(state.item) {
                    events = [...current(state.items)];
                    events[state.item.dayKey] = [state.item];
                    state.items = events;
                }
            //state.apiState = COMCYCLE.API_REFRESH;
            }
        }
            state.apiState = COMCYCLE.API_REFRESH;

        }
    }
    if(action.payload.data.users) {
        state.users = action.payload.data.users;
    }
    if(action.payload.data.selected) {
        state.selected = action.payload.data.selected;
    }
    if(action.payload.data.items) {
        state.items = DB.newCollection(action.payload.data.items, DayModel);
        
        state.initItems = action.payload.data.items;
    }
    if(action.payload.data.schedule) {
        state.schedule = action.payload.data.schedule;
        //localStorage.setItem("refreshView", 'calender');
    }
    if(action.payload.data.priority) {
        state.priority = action.payload.data.priority;
        //localStorage.setItem("refreshView", 'calender');
    }
    if(action.payload.data.event_types) {
        state.event_types = action.payload.data.event_types;
        //localStorage.setItem("refreshView", 'calender');
    }

    state.view = COMCYCLE.CREATE_TASK;
    
    if(action.type == "com_api_save/fulfilled" || action.type == "com_api_delete/fulfilled" || action.type == "GET_TASKS/fulfilled") {
        state.apiState = COMCYCLE.API_REFRESH;
    } else {
      state.apiState = COMCYCLE.API_READY;  
    }
    //;
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
})



/*
let newDossier = localStorage.getItem("newDossier");
if(newDossier) {
    if(window.location.pathname == '/dossiers/new') {
    newDossier = JSON.parse(newDossier);
    initialState.selected = newDossier;
    initialState.apiState = DOSSIER.API_READY;
    initialState.view = DOSSIER.VIEW_NEW;
    } else {
        localStorage.removeItem("newDossier");
    }
}
*/
let task = null;
const CommunicationCycleReducer = createSlice({
  name: 'CommunicationCycle',
  initialState,
  reducers: {
       cancelSchedule(state, action) {
            state.items = {...current(state.initItems)};

            state.apiState = COMCYCLE.API_REFRESH;
            state.needToUpdate = true;
           
        },
       createTaskForScheduleItem(state, action) {

                let currentItem = {...current(state.scheduleItem)};
                currentItem.name += "-b";
               state.scheduleItem = {...currentItem}
            //state.key = uuid().slice(0, 8);
            return state;
       },
       setItemForSchedule(state, action) {
            if(action.payload && action.payload?.item) {       
                state.scheduleItem = action.payload?.item;
            }
            
            return state;
       },
       createDossierItem(state, action) {
           if(action.payload) {
                let dossierTodoItem = CalenderHelperClass.createDossierItem(action.payload.day, action.payload.dossier);
                
            let events = state.items[action.payload.day.Key];
            if(events) {
                events.push(dossierTodoItem);
                state.items[dossierTodoItem.dayKey] = events;
            } else {
                state.items[dossierTodoItem.dayKey] = [dossierTodoItem];
            }
            
            state.apiState = COMCYCLE.API_REFRESH;
            state.needToUpdate = true;
                
                //events = CalenderHelperClass.addEvent([...events], state.item);
                //let events = current(state.items)[action.payload.day.from];
                //state.items = {...dossierTodoItem, dossierTodoItem};
           }
           return state;
           },
       checkItem(state, action) {
           state.dragOverElement = action.payload;
           if(action.payload && action.payload?.withCheck === true) {
                CalenderHelperClass.checkIs(action.payload, current(state.dragItem), current(state.items));
           }
           return state;
           },
       setSelectedUsers(state, action = null) {
           state.selectedUsers = action.payload;
           },
       getState(state, action = null) {
           return current(state)
           },
       setSelectedDate(state, action) {
           state.selectedDate = action.payload;
           },
       setDragItem(state, action) {
           state.dragItem = action.payload;
           },
       setUpdate(state, action) {
           state.needToUpdate = action.payload;
           },
       setChangedItems(state, action) {
           if(action.payload.item && action.payload.index >= 0) {
               state.items[action.payload.index] = action.payload.item;
           }
               state.needToUpdate = true;
        }
        ,
       storeCalenderSettings(state, action) {
               state.calenderSettings = {...state.calenderSettings, ...action.payload};
               localStorage.setItem("calender_settings", JSON.stringify(state.calenderSettings));
        }
        
    // omit existing reducers here
  },
  extraReducers(builder) {
      
    task = newTaskEvent;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));
    
    task = saveTask;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    task = getTasks;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    task = removeTask;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    task = getUserSchedules;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    builder.addMatcher(
      (action) => (action.type == "USER_CHECKAUTH/fulfilled" || action.type == "USER_LOGIN/fulfilled"),
      (state, action) => {
            if(action.payload.data.data.priority) {
                state.priority = action.payload.data.data.priority;
                //localStorage.setItem("refreshView", 'calender');
            }
            if(action.payload.data.data.event_types) {
                state.event_types = action.payload.data.data.event_types;
                //localStorage.setItem("refreshView", 'calender');
            }
            if(action.payload.data.data.users) {
                state.users = action.payload.data.data.users;
                //localStorage.setItem("refreshView", 'calender');
            }
          
       })


    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {

        state.items = null;
        state.selectedDate = moment();
        state.selectedUsers = [];
        state.users = [];
        state.item = null;
          
       })

    builder.addMatcher(
      (action) => action.type.endsWith('chat/receiveMessage'),
      (state, action) => {
          if(action?.payload?.event?.data) {
          let item = JSON.parse(action?.payload?.event?.data);
          if(item?.type == 'communicationcycle') {
//            state.apiState = COMCYCLE.API_REFRESH;
//            state.needToUpdate = true;
              
          }
            
//            if(action?.payload?.data?.data?.notification) {
//                state.notifications.push(action?.payload?.data?.data?.notification);
//            }
            }
       });

    
//    task = getTasks;
//    builder.addCase(task.fulfilled, ((state, action) => {return fullFilledEventHandler(state, action)})).addCase(task.rejected, ((state, action) => reject)).addCase(task.pending, ((state, action) => pending));
/*
    task = getTasks;
    builder.addCase(task.fulfilled, (state, action) => {
        fullFilledEventHandler(state, action);
        return;
    
    if(action.payload.data.item) {
        state.item = action.payload.data.item;
    }
    if(action.payload.data.selected) {
        state.selected = action.payload.data.selected;
    }
    if(action.payload.data.items) {
        state.items = action.payload.data.items;
    }
    state.view = COMCYCLE.CREATE_TASK;
    state.apiState = COMCYCLE.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;
    }).addCase(getTasks.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(getTasks.pending, (state, action) => {
        state.apiState = COMCYCLE.API_PROCESSING;
    });
*/    
  }
  })


export const saveTask = createAsyncThunk(COMCYCLE.API_SAVE, async (data:any, event) => {
    let response = null;
    try {
          response = await CommunicationCycleAPI.store(data);
          
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const newTaskEvent = createAsyncThunk(COMCYCLE.API_NEWITEM, async (data:any, event) => {
    let response = null;
    try {
        
          response = await CommunicationCycleAPI.new(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getTasks = createAsyncThunk(COMCYCLE.GET_TASKS, async (data:any= null, event) => {
    let response = null;
    try {
          response = await CommunicationCycleAPI.get(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const removeTask = createAsyncThunk(COMCYCLE.API_DELETE, async (key:string= null, event) => {
    let response = null;
    try {
          response = await CommunicationCycleAPI.delete(key);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getUserSchedules = createAsyncThunk("getUserSchedules", async (data:Object= null, event) => {
    let response = null;
    try {
          response = await CommunicationCycleAPI.getUserSchedules(data);
          
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    
    return response.data;
  }
)


  
/*
export const dossierStore = createAsyncThunk(DOSSIER.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.index();
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)
*/

export const { setChangedItems, storeCalenderSettings, setUpdate, setDragItem, checkItem,setSelectedDate, getState, setSelectedUsers, createDossierItem, setItemForSchedule, createTaskForScheduleItem, cancelSchedule} = CommunicationCycleReducer.actions;
export default CommunicationCycleReducer.reducer